import React, { useState, useMemo } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab, Box, Typography } from "@material-ui/core";
import SwipeableViews from "react-swipeable-views";
import ProspectEmailTab from "./ProspectEmailTab";
import ProspectNotesTab from "./ProspectNotesTab";
import ProspectFollowUpTab from "./ProspectFollowUpTab";

// Local TabPanel component
const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`prospect-tabpanel-${index}`}
      aria-labelledby={`prospect-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3}>
          <Typography component='div'>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    minHeight: "400px",
  },
  note: {
    color: "#eb5757",
    fontSize: "14px",
    fontWeight: 500,
    margin: "15px",
    display: "block",
  },
}));

const ProspectTabsContent = ({
  open,
  setOpen,
  setLoading,
  loadAllCampaigns,
  prospectData,
  loadLeadsGeneration,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleSwipeChange = index => {
    setActiveTab(index);
  };

  const a11yProps = index => ({
    id: `prospect-tab-${index}`,
    "aria-controls": `prospect-tabpanel-${index}`,
  });

  const entityId = useMemo(() => prospectData?.id, [prospectData]);

  return (
    <div className='prospectTabs'>
      <div className={classes.root}>
        <AppBar position='static' color='default'>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor='primary'
            textColor='primary'
            variant='fullWidth'>
            <Tab label='Email' {...a11yProps(0)} />
            <Tab label='Notes' {...a11yProps(1)} />
            <Tab label='Follow-up' {...a11yProps(2)} />
          </Tabs>
        </AppBar>

        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeTab}
          onChangeIndex={handleSwipeChange}>
          <TabPanel value={activeTab} index={0} dir={theme.direction}>
            <ProspectEmailTab
              prospectData={prospectData}
              setOpen={setOpen}
              setLoading={setLoading}
              loadAllCampaigns={loadAllCampaigns}
              loadLeadsGeneration={loadLeadsGeneration}
            />
          </TabPanel>

          <TabPanel value={activeTab} index={1} dir={theme.direction}>
            <ProspectNotesTab entityId={entityId} entityType='prospect' />
          </TabPanel>

          <TabPanel value={activeTab} index={2} dir={theme.direction}>
            <ProspectFollowUpTab prospectData={prospectData} />
          </TabPanel>
        </SwipeableViews>
      </div>

      {/* {activeTab === 0 && (
        <span className={classes.note}>
          Images are supported only. (JPEG, JPG, PNG and GIF)
        </span>
      )} */}
    </div>
  );
};

export default ProspectTabsContent;
